import { render, staticRenderFns } from "./CommentButton.vue?vue&type=template&id=34543cba&lang=pug"
import script from "./CommentButton.vue?vue&type=script&lang=ts"
export * from "./CommentButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports